module.exports = __webpack_public_path__ + "static/img/Bachelor_010688.8fd691d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010688.jpg
// module id = 214
// module chunks = 0